export default "__VITE_ASSET__3d60b833__"